import { ExternalScriptsApiResponse } from "types/ApiResponses";

const htmlLang = document.documentElement.lang;

export const retrieveFormById = async (formId : number | string, formsUrl : string) : Promise<string> => {
  const pageUrl = `${window.location.origin}${window.location.pathname}`;
  const response = await fetch(`${formsUrl}/wp-json/aq-central/v1/forms/get/id/${formId}?region_locale=${htmlLang}&page_url=${pageUrl}`);
  if(!response.ok) {
    throw new Error('Form rendering error: ' + response.status);
  }

  const resultText = await response.json();
  
  return resultText;
}

export const fetchScripts = async (formsUrl : string) : Promise<ExternalScriptsApiResponse> => {
  const response = await fetch(`${formsUrl}/wp-json/aq-central/v1/forms/scripts?region_locale=${htmlLang}`);
  if(!response.ok) {
    throw new Error('Form rendering error: ' + response.status);
  }

  const resultText : ExternalScriptsApiResponse = await response.json();
  
  return resultText;
}